// Qué cuenta como COMPROBANTE adjunto a una orden.
//
// Solo imágenes y PDFs: es lo que el cliente manda para probar un pago. Quedan afuera
// los stickers (WhatsApp los manda siempre como image/webp), las notas de voz (audio/*)
// y los videos. Todo eso se sigue viendo en el chat del Inbox — simplemente no es un
// adjunto de la orden ni cuenta como "mandó el comprobante".
//
// Mismo criterio del lado del backend en supabase/functions/_shared/receipts.ts.

// Filtro equivalente para PostgREST, para no traer de más en las queries.
// Se usa junto con .neq('media_mime_type', 'image/webp').
export const RECEIPT_MIME_OR = 'media_mime_type.like.image/*,media_mime_type.eq.application/pdf';
export const STICKER_MIME = 'image/webp';

// Clasificación (whatsapp_logs.media_kind, migr 105): fotos de reviews ('review') y lo marcado
// "No es comprobante" ('other') NO son comprobantes. null = automático; 'receipt' = confirmado.
// Para PostgREST, como un .or() APARTE (dos .or() se combinan con AND): .or(RECEIPT_KIND_OR)
export const RECEIPT_KIND_OR = 'media_kind.is.null,media_kind.eq.receipt';

export function isReceiptMime(mime?: string | null): boolean {
  const m = String(mime || '').toLowerCase().trim();
  if (!m) return false;
  if (m === STICKER_MIME) return false; // sticker de WhatsApp
  return m.startsWith('image/') || m === 'application/pdf';
}
